import React, { useState } from "react";
import { Carousel } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { ToastContainer } from "react-toastify";
import { TransparentButton, SolidButton } from "../../../../library/button";
import SelectContainer from "./select-container";
import {
  changeCampaignsModal,
  requestChangeMailPlan,
} from "../../../../../redux/actions/campaigns";
import { sendErrorNotification } from "../../../../universal/notifications/notifications";
import { Popup } from "../../../../library/popup";
import "./style.scss";

const Index = () => {
  const dispatch = useDispatch();

  const modalState = useSelector(
    (state) => state.campaigns.showModals.changeEmailReachModal
  );
  const selectedCompany = useSelector(
    (state) =>
      state &&
      state.activeCompany &&
      state.activeCompany.activeCompany &&
      state.activeCompany.activeCompany.id
  );

  const activeChannel = useSelector((state) => state.campaigns.activeChannel);
  const creditsAvailable = useSelector(
    (state) => state.campaigns.activeChannel.credits.data.total
  );

  const [loading, setLoading] = useState(false);

  const [stepProgress, _] = useState(0);

  const [activeSelection, setActiveSelection] = useState({
    ref: "step1",
    amount: 250,
    price: 149,
  });

  const handleSlideChange = (selection) => {
    switch (selection) {
      case 0:
        setActiveSelection({ ref: "step1", amount: 250, price: 399 });
        break;
      case 20:
        setActiveSelection({ ref: "step2", amount: 500, price: 699 });
        break;
      case 40:
        setActiveSelection({ ref: "step3", amount: 1000, price: 1299 });
        break;
      case 60:
        setActiveSelection({ ref: "step4", amount: 2500, price: 2199 });
        break;
      case 80:
        setActiveSelection({ ref: "step5", amount: 5000, price: 3999 });
        break;
      case 100:
        setActiveSelection({ ref: "step6", amount: 10000, price: 5999 });
        break;
      default:
        setActiveSelection({ ref: "step1", amount: 250, price: 399 });
        break;
    }
  };

  const handleClose = () => {
    dispatch(changeCampaignsModal({ changeEmailReachModal: false }));
  };

  const clickCheckout = () => {
    if (activeSelection.amount !== creditsAvailable) {
      setLoading(true);
      dispatch(
        requestChangeMailPlan({
          companyId: selectedCompany,
          channelId: activeChannel.username,
          channelRef: activeChannel.id,
          plan: activeSelection,
        })
      );
    } else {
      sendErrorNotification("Du har allerede denne planen.");
    }
  };

  return (
    <Popup
      onClose={handleClose}
      show={modalState}
      title="Oppgrader rekkevidde"
      description="Du kan få tilgang på enda flere e-postutsendelser per måned ved å oppgradere til en høyere plan."
      buttons={[
        <TransparentButton
          title="Avbryt"
          type="button"
          data-dismiss="modal"
          onClick={() => handleClose()}
        />,
        <SolidButton
          icon={
            loading ? (
              <i className="fas fa-circle-notch fa-spin" />
            ) : (
              <i class="fad fa-shopping-cart" />
            )
          }
          color="blue"
          title={loading ? "Oppgraderer.." : "Oppgrader"}
          onClick={() => clickCheckout()}
          type="button"
        />,
      ]}
    >
      <div className="change-email-plan-content-container">
        <Carousel
          activeIndex={stepProgress}
          indicators={false}
          controls={false}
        >
          <Carousel.Item className="selection-item">
            <SelectContainer
              handleSlideChange={handleSlideChange}
              activeSelection={activeSelection}
            />
          </Carousel.Item>
        </Carousel>
      </div>
      <ToastContainer />
    </Popup>
  );
};

export default Index;
